export const SALUTAIONS = [
	'Frau',
	'Herr',
	'Divers'
]
